import { createAuthGuard, type RedirectLoginOptions } from '@auth0/auth0-vue'
import { LocalStorage } from 'quasar'
import type { RouteLocation } from 'vue-router'
import auth0Plugin from '@/setups/authSetup'

const LOGIN_CONNECTION_KEY = 'loginConnection'

export const PASSWORD_CONNECTION =
  import.meta.env.VITE_AUTH0_PASSWORD_CONNECTION ?? 'Username-Password-Authentication'

// Some users share an email domain with an SSO org but aren't in its IdP group
// (e.g. Cushman Capital Markets). Home Realm Discovery would send them to that
// SSO, so they log in through /login/password and we pin the connection here.
// Every later login reuses it, otherwise an expired session sends them back to
// an SSO they can't get through.
export function rememberLoginConnection(connection: string) {
  LocalStorage.setItem(LOGIN_CONNECTION_KEY, connection)
}

function loginOptions(): RedirectLoginOptions | undefined {
  const connection = LocalStorage.getItem<string>(LOGIN_CONNECTION_KEY)
  return connection ? { authorizationParams: { connection } } : undefined
}

export function login() {
  return auth0Plugin.loginWithRedirect(loginOptions())
}

// Same as auth0-vue's authGuard, but it redirects with the saved connection.
// The stock one would send password users to their domain's SSO.
export function authGuard(to: RouteLocation) {
  return createAuthGuard({ redirectLoginOptions: loginOptions() })(to)
}
